interface ErrorBannerProps {
  error: string | null
}

export function ErrorBanner({ error }: ErrorBannerProps) {
  if (!error) return null
  return (
    <div
      style={{
        margin: 16,
        padding: 12,
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: 8,
        color: '#dc2626',
        fontSize: 14,
      }}
    >
      ❌ {error}
    </div>
  )
}
